import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Si la academia muestra el examen — ADR-2026-10-07-la-academia-sin-examen-por-ahora.
 *
 * Por ahora los cursos no tienen examen: se miran las lecciones y el progreso
 * avanza con cada una, pero no hay nada que rendir ni certificado que bajar (el
 * certificado sale del examen aprobado). Apagarlo con una constante y no borrando
 * deja intactos el examen, la revisión, el certificado y las funciones de la base
 * para el día que vuelva: es pasar esto a `true`.
 *
 * Con `false`, las pantallas dejan de nombrar el examen (bajadas, pie de las cards,
 * panel del curso, barra de mobile) y las rutas `/examen` y `/revision` vuelven al
 * curso, así un link viejo no abre una pantalla que ya no se ofrece.
 */
export const EXAMEN_HABILITADO = false;

/** Monta la pantalla del examen o de la revisión sólo con el examen encendido. */
export function SoloConExamen({ children }: { children: ReactNode }) {
  const { slug } = useParams<{ slug: string }>();
  if (EXAMEN_HABILITADO) return <>{children}</>;
  return <Navigate to={slug ? `/academia/${slug}` : '/academia'} replace />;
}
